/*
  Homepage "How we make" video (sections/nr-home-grow.liquid). Plays the
  muted loop only while it is near the screen, and fills each step's bar in
  time with the loop: the clip is split into equal parts, one per step, so
  step one fills while the seed sprouts, and so on. Visitors who prefer
  reduced motion get the still frame with every step lit.
*/
if (!customElements.get('nr-home-grow-video')) {
  class NrHomeGrowVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      const section = this.closest('.nr-home-grow');
      this.steps = section ? Array.from(section.querySelectorAll('.nr-home-steps li')) : [];
      if (!this.video || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.tick = () => {
        this.frame = null;
        this.sync();
        if (!this.video.paused) this.frame = requestAnimationFrame(this.tick);
      };
      this.onPlay = () => {
        section.classList.add('is-playing');
        if (!this.frame) this.frame = requestAnimationFrame(this.tick);
      };
      this.video.addEventListener('playing', this.onPlay);

      if (!('IntersectionObserver' in window)) {
        this.video.play().catch(() => {});
        return;
      }
      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => (entry.isIntersecting ? this.video.play().catch(() => {}) : this.video.pause()));
        },
        { rootMargin: '300px 0px' }
      );
      this.observer.observe(this.video);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.frame) cancelAnimationFrame(this.frame);
      if (this.video && this.onPlay) this.video.removeEventListener('playing', this.onPlay);
    }

    sync() {
      const count = this.steps.length;
      const length = this.video.duration;
      if (!count || !length) return;
      const at = (this.video.currentTime / length) * count;
      this.steps.forEach((step, i) => {
        const fill = Math.max(0, Math.min(1, at - i));
        step.style.setProperty('--nr-step-fill', fill.toFixed(3));
        step.classList.toggle('is-active', at >= i && at < i + 1);
      });
    }
  }

  customElements.define('nr-home-grow-video', NrHomeGrowVideo);
}
